import React from 'react';
import { Link } from 'react-router-dom';
import { navigationConfig } from '../data/navigationData';

const Logo = ({ variant, className = '' }) => {
  const { logo } = navigationConfig;
  
  return (
    <Link to="/" className={`nav-logo ${className}`}>
      <img
        src={logo.src}
        alt={logo.alt}
      />
    </Link>
  );
};

export default Logo;